export default {
	articles: "Articles",
	offerRequests: "Offers",
	offerRequestsHintTitle: "New: offers for large quantities and series",
	offerRequestsHintText:
		"You can now request offers here for large quantities, series parts or automated robotic production.",
	orders: "Order History",
	cart: "Cart",
	account: "Account",
	settings: "Settings",
	manageUsers: "Manage users",
	logout: "Log out",
	hide: "Hide",
	privateAccount: "Private account (Customer number: {customerId})",
	companyAccount: "{companyName} (Customer number: {customerId})",
	footer: {
		materials: "Materials",
		materialsTooltip: "List of available materials",
		privacy: "Privacy",
		privacyTooltip: "Privacy policy",
		terms: "Terms",
		termsTooltip: "Blexon's general terms and conditions",
		imprint: "Imprint",
		imprintTooltip: "Imprint",
		languageTooltip: "Change your language in the account settings",
	},
};
